import type { WafHitMode } from "@/lib/api";
import type { InfraStatusTone } from "@/lib/infra-placement";

/** バックエンド WafDashboardQuery.PeriodHours と同じ。ログは 30 日で消える。 */
export const WAF_PERIODS = [
	{ hours: 24, label: "直近 24 時間" },
	{ hours: 24 * 7, label: "直近 7 日" },
	{ hours: 24 * 30, label: "直近 30 日" },
] as const;

/** 表に出す行数。バックエンド WafDashboardQuery.TopLimit と同じ (ルールごとにこの行数まで返ってくる)。 */
export const WAF_TOP_ROWS = 100;

const MANAGED_RULE_PREFIX = "AWSManagedRules";

/** "AWSManagedRulesCommonRuleSet" と中のルールを "CommonRuleSet / NoUserAgent_HEADER" のように短くする。 */
export function wafRuleLabel(rule: string, subRule: string | null): string {
	const group = rule.startsWith(MANAGED_RULE_PREFIX)
		? rule.slice(MANAGED_RULE_PREFIX.length)
		: rule;
	return subRule === null ? group : `${group} / ${subRule}`;
}

export function wafHitModeStatus(mode: WafHitMode): {
	label: string;
	tone?: InfraStatusTone;
	description: string;
} {
	switch (mode) {
		case "block":
			return { label: "ブロック", tone: "danger", description: "このルールで止めました。" };
		case "count":
			return {
				label: "カウント",
				tone: "warning",
				description: "いまは数えるだけです。ブロックに替えると止まります。",
			};
		case "excluded":
			return {
				label: "カウント固定",
				description: "グループをブロックに替えても、このルールは数えるだけです。",
			};
	}
}
